import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhishingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phishing"}/>
}
